export default __webpack_public_path__ + "static/media/screenshot19.9568138c.jpg";